import { useMemo } from "react";
import { useWatch } from "react-hook-form";

import type { InvitedModes } from "api/models/draftRequest.model";
import { useGetFreightModesConfig } from "api/queries/location/useGetFreightModesConfig";
import { getSelectedInvitedModeValues } from "@RequestFormV2/utils/invitedModesHelpers";

export function useIsParcelFreight() {
  const location = useWatch({ name: "organizational.location" });
  const invitedModes = useWatch({ name: "invited_modes" }) as InvitedModes | undefined;

  const { data: freightModesConfig } = useGetFreightModesConfig(location ?? "", {
    enabled: !!location,
  });

  return useMemo(() => {
    const selected = getSelectedInvitedModeValues(invitedModes);
    if (!selected.length || !freightModesConfig?.freight_modes?.available_modes) return false;

    const availableModes = freightModesConfig.freight_modes.available_modes;
    return selected.some((modeValue) => {
      const mode = availableModes.find(
        (m) => m.value === modeValue || m.options?.some((opt) => opt.value === modeValue),
      );
      return mode?.type === "parcel" || modeValue === "parcel";
    });
  }, [invitedModes, freightModesConfig]);
}
